<ngx-spinner [name]="'consultar-pedidos'" type="ball-clip-rotate-pulse" [fullScreen]="false"
  bdColor="rgba(0, 0, 0, 0.2)"></ngx-spinner>
<mat-card>
  <mat-card-header>
    <mat-card-title *ngIf="!bConsulta">Consultar pedidos</mat-card-title>
    <mat-card-title *ngIf="bConsulta">


      Consultar pedido {{f.id.value}} |
    </mat-card-title>
    <small *ngIf="bConsulta" style="font-weight: normal; font-size: 10; display: inline-block; margin-top: 2px;">
      {{f.dispositivo.value}}
      -
      {{f.plataforma.value}} - ({{f.data.value}} às
      {{f.hora.value}}) - Versão sistema: {{f.versaoSistema.value}}
    </small>

    <button *ngIf="bConsulta" mat-button color="warn" style="font-size: x-small; margin-top: -5px;" (click)="voltar()">
      <mat-icon>arrow_back</mat-icon> Voltar
    </button>
  </mat-card-header>
  <mat-divider></mat-divider>

  <mat-card-content *ngIf="!bConsulta">

    <div class="row">
      <div class="col-auto">
        <mat-form-field appearance="fill" [floatLabel]="'always'">
          <mat-label>Buscar por</mat-label>
          <mat-select [(ngModel)]="sTipoBusca" (ngModelChange)="changeSelect()">
            <mat-option *ngFor="let tipo of aTiposBusca" [value]="tipo.value">
              {{tipo.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-auto" *ngIf="sTipoBusca === 'Período' || sTipoBusca === 'Rota'">
        <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>Período</mat-label>
          <mat-date-range-input [formGroup]="range" [rangePicker]="picker" [max]="maxDate" disabled>
            <input matStartDate formControlName="start" placeholder="Início" (dateChange)="dateChanged($event)">
            <input matEndDate formControlName="end" placeholder="Fim">
          </mat-date-range-input>
          <mat-hint align="start" *ngIf="sTipoBusca === 'Rota'">
            <strong>* O filtro é realizado com base na previsão agendada de saída da rota, não da saída do
              pedido ou a data de realização;</strong>
          </mat-hint>

          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker disabled="false"></mat-date-range-picker>

          <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Data inicial inválida
          </mat-error>
          <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Data final inválida</mat-error>
        </mat-form-field>
      </div>

      <div class="col-2" *ngIf="sTipoBusca === 'IDPedido'">
        <mat-form-field appearance="outline" [floatLabel]="'always'">
          <mat-label>Nº</mat-label>
          <input type="number" matInput [(ngModel)]="idPedido" id="numeroPedido"
            (keypress)="($event.charCode==13)?buscarPedidoPorNumero(idPedido):null">
        </mat-form-field>
      </div>

      <div class="col-sm-4" *ngIf="sTipoBusca === 'Rota'">
        <mat-form-field appearance="fill" [floatLabel]="'always'">
          <mat-label>Rotas</mat-label>
          <mat-select [(ngModel)]="sBuscaIDPoligono" (ngModelChange)="filtrarSelect()">
            <mat-option *ngFor="let rota of aRotas" [value]="rota.idPoligono">
              {{rota.nomeCidade}} - {{rota.stringCidade}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-auto">
        <button class="mt-4" mat-flat-button color="primary" (click)="buscarPedidosPeriodo()">
          <mat-icon>search</mat-icon> Buscar
        </button>
      </div>
    </div>

    <div class="row" *ngIf="sTipoBusca === 'Período' || sTipoBusca === 'Rota'">
      <div class="col-sm-4">
        <mat-form-field appearance="outline" [floatLabel]="'always'">
          <mat-label>Filtro</mat-label>
          <input matInput (keyup)="aplicarFiltroTabela($event)" placeholder="Filtro">
        </mat-form-field>
      </div>

      <div class="col-2" *ngIf="sTipoBusca === 'Período'">
        <mat-form-field appearance="fill" [floatLabel]="'always'">
          <mat-label>Status do pedido</mat-label>
          <mat-select [(ngModel)]="sBuscaStatusPedido" (ngModelChange)="filtrarSelect()">
            <mat-option *ngFor="let tipo of aTiposBuscaStatusPedido" [value]="tipo.value">
              {{tipo.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-2" *ngIf="sTipoBusca === 'Período'">
        <mat-form-field appearance="fill" [floatLabel]="'always'">
          <mat-label>Status do pagamento</mat-label>
          <mat-select [(ngModel)]="sBuscaStatusPagamento" (ngModelChange)="filtrarSelect()">
            <mat-option *ngFor="let tipo of aTiposStatusPagamento" [value]="tipo.value">
              {{tipo.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-auto" *ngIf="sTipoBusca === 'Período'">
        <mat-form-field appearance="fill" [floatLabel]="'always'">
          <mat-label>Cidade</mat-label>
          <mat-select [(ngModel)]="sBuscaCidade" (ngModelChange)="filtrarSelect()">
            <mat-option *ngFor="let tipo of aCidades" [value]="tipo.value">
              {{tipo.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <!-- <div class="col-auto" *ngIf="sTipoBusca === 'Período' || sTipoBusca === 'Rota'">
        <button mat-stroked-button color="primary" class="mt-4" (click)="bloquearSelecaoTabela()">
          <mat-icon>{{iconeCadeado}}</mat-icon>
        </button>
      </div> -->

      <div class="col-auto" *ngIf="sTipoBusca === 'Período' || sTipoBusca === 'Rota'">
        <button class="mt-4 small-button" mat-stroked-button color="warn" (click)="alertConfirmaPagamentoDemanda()">
          <mat-icon>check</mat-icon> Confirmar pagamentos
        </button>
      </div>

      <div class="col-auto" *ngIf="selection.selected.length > 0">
        <button class="mt-4 small-button" mat-stroked-button color="warn" (click)="alertAlterarStatusDemanda()">
          <mat-icon>edit</mat-icon> Alterar status
        </button>
      </div>

      <div class="col-auto" *ngIf="selection.selected.length > 0">
        <button class="mt-4 small-button" mat-stroked-button color="warn" (click)="alertGerarBoletoDemanda()">
          <mat-icon>sync</mat-icon> Gerar boletos
        </button>
      </div>


      <div class="col-auto" *ngIf="selection.selected.length > 0">
        <!-- <div class="row"> -->
        <!-- <div> -->
        <mat-form-field appearance="fill" [floatLabel]="'always'" style="width:80%; margin-bottom: -2.5em;">
          <mat-label>Tipo de impressão</mat-label>
          <mat-select [(ngModel)]="sTipoImpressao">
            <mat-option *ngFor="let tipo of aTipoImpressao" [value]="tipo.name">
              {{tipo.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-icon (click)="imprimirTipo()" color="primary"
          style="font-size: 30px; cursor: pointer; position:absolute; right: 30px; top: 16px">print</mat-icon>
        <!-- </div> -->
        <!-- </div> -->
      </div>

    </div>

    <div class="row mt-2" *ngIf="sTipoBusca === 'Período' || sTipoBusca === 'Rota'">
      <div class="col-sm">
        <table mat-table [dataSource]="pedidosSource" class="mat-elevation-z2" style="width: 100%;">

          <!-- Checkbox Column -->
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
              <mat-checkbox (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
              <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
              </mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="ID">
            <th mat-header-cell *matHeaderCellDef> Nº </th>
            <td mat-cell *matCellDef="let element"> {{element.ID}} </td>
          </ng-container>

          <ng-container matColumnDef="Rota">
            <th mat-header-cell *matHeaderCellDef> Rota </th>
            <td mat-cell *matCellDef="let element">
              <mat-icon aria-label="Rota cadastrada" *ngIf="element.TimestampPrevisaoRota" color="primary">check
              </mat-icon>
              <mat-icon aria-label="Rota não cadastrada" *ngIf="!element.TimestampPrevisaoRota" color="warn">
                warning</mat-icon>
            </td>
          </ng-container>

          <ng-container matColumnDef="Nome">
            <th mat-header-cell *matHeaderCellDef> Cliente </th>
            <td mat-cell *matCellDef="let element"> {{element.Nome}} </td>
          </ng-container>

          <ng-container matColumnDef="Status">
            <th mat-header-cell *matHeaderCellDef> Status </th>
            <td mat-cell *matCellDef="let element">
              <div class="retangulo_tabela"
                [ngStyle]="{'background': (element.Status=='Confirmado') ? '#69B3FE' : (element.Status=='Em separação' ? '#FEA569' : (element.Status=='Em rota' ? '#FE696A' : (element.Status=='Entregue' ? '#42D697' : '#F34770')))}">
                {{element.Status}}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="StatusPagamento">
            <th mat-header-cell *matHeaderCellDef> Status Pagamento </th>
            <td mat-cell *matCellDef="let element">
              <div class="retangulo_tabela"
                [ngStyle]="{'background': (element.StatusPagamento=='Pendente') ? '#FEA569' : (element.StatusPagamento=='Pago' ? '#42D697' : '#F34770')}">
                {{element.StatusPagamento}}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="Cidade">
            <th mat-header-cell *matHeaderCellDef> Cidade </th>
            <td mat-cell *matCellDef="let element"> {{element.Cidade}} </td>
          </ng-container>

          <ng-container matColumnDef="DataHora">
            <th mat-header-cell *matHeaderCellDef> Data / Hora solicitação </th>
            <td mat-cell *matCellDef="let element"> {{element.Data}} às {{element.Hora}} </td>
          </ng-container>

          <ng-container matColumnDef="SomaCorreta">
            <th mat-header-cell *matHeaderCellDef> Soma Correta </th>
            <td mat-cell *matCellDef="let element">
              <div class="retangulo_tabela"
                [ngStyle]="{'background': (element.SomaCorreta === 'OK' ? '#42D697' : '#F34770')}">
                {{element.SomaCorreta}}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="Consultar">
            <th mat-header-cell *matHeaderCellDef> Consultar </th>
            <td mat-cell *matCellDef="let element">
              <button mat-icon-button matTooltip="Detalhar" (click)="consultarSolicitacao(element)" class="iconbutton"
                color="primary">
                <mat-icon aria-label="Expandir">search</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <!-- <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="consultarSolicitacao(row)"> -->
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)">
          </tr>

          <!-- Row shown when there is no matching data that will be provided to the wrapper table. -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="10" style="text-align: center;">Não há pedidos no sistema ou com o
              filtro definido
            </td>
          </tr>
        </table>

        <mat-paginator [pageSizeOptions]="[10, 15, 20, 25, 50, 100]" [pageIndex]="pageIndex"
          (page)="paginatorEvent($event)" [showFirstLastButtons]="true"></mat-paginator>
      </div>
    </div>
  </mat-card-content>

  <mat-card-content *ngIf="bConsulta">

    <form [formGroup]="pedidoForm">
      <div class="row">
        <div class="col-sm" *ngIf="f.status.value !== 'Cancelado'">
          <mat-horizontal-stepper labelPosition="bottom" #stepper>

            <mat-step editable="false">
              <ng-template matStepLabel>Confirmado
                <div style="font-size: 10px;">{{f.data.value}} às {{f.hora.value}}</div>
              </ng-template>
            </mat-step>

            <mat-step editable="false">
              <ng-template matStepLabel>Em separação
                <div
                  *ngIf="f.status.value === 'Em separação' || f.status.value === 'Em rota' || f.status.value === 'Entregue' || f.status.value === 'Cancelado'"
                  style="font-size: 10px;">
                  {{f.dataSeparacao.value}} às {{f.horaSeparacao.value}}
                </div>
              </ng-template>
            </mat-step>

            <mat-step editable="false">
              <ng-template matStepLabel>Em rota
                <div
                  *ngIf="f.status.value === 'Em rota' || f.status.value === 'Entregue' || f.status.value === 'Cancelado'"
                  style="font-size: 10px;">{{f.dataRota.value}}
                  às {{f.horaRota.value}}</div>
              </ng-template>
            </mat-step>

            <mat-step editable="false">
              <ng-template matStepLabel>Entregue
                <div *ngIf="f.status.value === 'Entregue'" style="font-size: 10px;">
                  {{f.dataEntregue.value}} às {{f.horaEntregue.value}}</div>
              </ng-template>
            </mat-step>

          </mat-horizontal-stepper>
        </div>

        <div class="col-sm d-flex justify-content-center" *ngIf="f.status.value === 'Cancelado'">
          <mat-horizontal-stepper labelPosition="bottom" #stepper>
            <mat-step editable="false" id="stepper_cancelado">
              <ng-template matStepLabel>Cancelado
                <div *ngIf="f.status.value === 'Cancelado'" style="font-size: 10px;">
                  {{f.dataCancelado.value}} às {{f.horaCancelado.value}}</div>
              </ng-template>
            </mat-step>
          </mat-horizontal-stepper>
        </div>

        <div class="col-sm-6" *ngIf="f.status.value === 'Cancelado'">
          <mat-form-field appearance="outline" [floatLabel]="'always'">
            <mat-label>Motivo cancelamento</mat-label>
            <textarea type="text" matInput formControlName="motivoCancelamento" maxlength="200" rows="4"
              readonly="true"></textarea>
          </mat-form-field>
        </div>
      </div>


      <div class="row" style="margin-top: -25px;">
        <!-- Coluna à esquerda -->
        <div class="col-sm">
          <div class="row">

            <div class="col-auto">
              <h1 class="customH1">Informações Gerais</h1>
            </div>
            <div class="col-sm">
              <hr />
            </div>

            <div class="col-auto"
              *ngIf="f.formaPagamento.value === 'Boleto' && f.statusBoleto.value !== 'Pago' && f.pdfBase64.value?.length > 20">
              <button mat-button color="primary" (click)="imprimirBoleto(1)">
                <mat-icon>cloud_download</mat-icon> Download Boleto
              </button>
            </div>

            <div class="col-auto"
              *ngIf="f.formaPagamento.value === 'Boleto' && f.statusBoleto.value !== 'Pago' && f.pdfBase64Parcela2.value?.length > 20">
              <button mat-button color="primary" (click)="imprimirBoleto(2)">
                <mat-icon>cloud_download</mat-icon> Download Boleto (2)
              </button>
            </div>

            <div class="col-auto">
              <button mat-button color="primary" (click)="alertTipoImpressao()">
                <mat-icon>print</mat-icon> Imprimir Pedido
              </button>
            </div>
          </div>

          <div class="borda">
            <div class="row">
              <div class="col-sm-3">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                  <mat-label>Nome</mat-label>
                  <input type="text" matInput formControlName="nome" required maxlength="100" readonly="true">
                </mat-form-field>
              </div>

              <div class="col-3">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                  <mat-label>Telefone</mat-label>
                  <input type="text" matInput formControlName="telefone" required maxlength="100" readonly="true">
                </mat-form-field>
              </div>

              <div class="col-3" *ngIf="f.telefoneSecundario.value.length > 0">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                  <mat-label>Telefone secundário</mat-label>
                  <input type="text" matInput formControlName="telefoneSecundario" required maxlength="100"
                    readonly="true">
                </mat-form-field>
              </div>

              <div class="col-sm-3">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                  <mat-label>E-mail</mat-label>
                  <input type="text" matInput formControlName="email" required maxlength="100" readonly="true">
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-sm" *ngIf="f.observacao.value.length > 0">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                  <mat-label>Observação</mat-label>
                  <textarea type="text" matInput formControlName="observacao" maxlength="200"
                    readonly="true"></textarea>
                </mat-form-field>
              </div>

              <div class="col-auto">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                  <mat-label>Vendedor</mat-label>
                  <input type="text" matInput formControlName="nomeVendedor" maxlength="100" readonly="true">
                </mat-form-field>
              </div>

              <div class="col-auto" *ngIf="f.responsavelCompra.value.length > 0">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                  <mat-label>Responsável atual pela compra</mat-label>
                  <input type="text" matInput formControlName="responsavelCompra" maxlength="100" readonly="true">
                </mat-form-field>
              </div>

              <div class="col-sm" *ngIf="f.idDispositivo.value.length > 0">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                  <mat-label>ID Dispositivo</mat-label>
                  <input type="text" matInput formControlName="idDispositivo" maxlength="100" readonly="true">
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-auto">
              <h1 class="customH1">Dados para entrega</h1>
            </div>
            <div class="col-sm">
              <hr />
            </div>
          </div>

          <div class="borda">
            <div class="row">
              <div class="col-sm-5">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                  <mat-label>Logradouro</mat-label>
                  <input type="text" matInput formControlName="logradouro" required maxlength="100" readonly="true">
                </mat-form-field>
              </div>

              <div class="col-sm-2" *ngIf="f.complemento.value.length > 0">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                  <mat-label>Complemento</mat-label>
                  <input type="text" matInput formControlName="complemento" required maxlength="100" readonly="true">
                </mat-form-field>
              </div>

              <div class="col-2">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                  <mat-label>Número</mat-label>
                  <input type="text" matInput formControlName="numero" required maxlength="100" readonly="true">
                </mat-form-field>
              </div>

              <div class="col-sm-4">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                  <mat-label>Bairro</mat-label>
                  <input type="text" matInput formControlName="bairro" required maxlength="100" readonly="true">
                </mat-form-field>
              </div>

              <div class="col-sm-6" *ngIf="f.referencia.value.length > 0">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                  <mat-label>Referencia</mat-label>
                  <input type="text" matInput formControlName="referencia" maxlength="100" readonly="true">
                </mat-form-field>
              </div>

              <div class="col-auto">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                  <mat-label>Cidade</mat-label>
                  <input type="text" matInput formControlName="cidade" maxlength="100" readonly="true">
                </mat-form-field>
              </div>

              <div class="col-2">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                  <mat-label>UF</mat-label>
                  <input type="text" matInput formControlName="uf" maxlength="100" readonly="true">
                </mat-form-field>
              </div>

              <div class="col-auto" *ngIf="f.nomeRota.value">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                  <mat-label>Nome da rota</mat-label>
                  <input type="text" matInput formControlName="nomeRota" maxlength="100" readonly="true">
                </mat-form-field>
              </div>

              <div class="col-auto"
                *ngIf="f.latitude.value && f.status.value !== 'Entregue' && f.status.value !== 'Cancelado'">
                <button mat-stroked-button color="primary" class="mt-4" (click)="visualizarMapaCliente()">
                  <mat-icon>remove_red_eye</mat-icon> Ponto no mapa
                </button>
              </div>

              <div class="col-sm-3">
                <mat-form-field appearance="fill">
                  <mat-label>Data previsão da rota</mat-label>
                  <input matInput [min]="maxDate" [matDatepicker]="picker" [formControl]="datePickerRotaControl">
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
          </div>


          <div class="row mt-2">
            <div class="col-auto">
              <h1 class="customH1">Pagamento</h1>
            </div>
            <div class="col-sm">
              <hr />
            </div>
          </div>

          <div class="borda">
            <div class="row">
              <div class="col-auto">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                  <mat-label>Forma de pagamento</mat-label>
                  <input type="text" matInput formControlName="formaPagamento" maxlength="100" readonly="true">
                </mat-form-field>
              </div>

              <div class="col-1"
                *ngIf="f.formaPagamento.value === 'Cartão de débito' || f.formaPagamento.value === 'Cartão de crédito'">
                <img src="{{f.srcImagemCartao.value}}" alt="{{f.bandeiraCartao.value}}" width="45px"
                  style="margin-top: 27px;">
              </div>

              <div class="col-auto" *ngIf="f.formaPagamento.value === 'Boleto'">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                  <mat-label>Nº de parcelas</mat-label>
                  <input type="text" matInput formControlName="numeroParcelas" maxlength="100" readonly="true">
                </mat-form-field>
              </div>

              <div class="col-auto" *ngIf="f.numeroParcelas.value === 1 && f.formaPagamento.value === 'Boleto'">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                  <mat-label>Prazo do boleto</mat-label>
                  <input type="text" matInput formControlName="prazoBoleto" maxlength="100" readonly="true">
                </mat-form-field>
              </div>

              <div class="col-auto" *ngIf="f.formaPagamento.value === 'Boleto'">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                  <mat-label>Valor boleto</mat-label>
                  <input id="valorBoleto" type="text" matInput formControlName="valorBoleto" maxlength="100"
                    readonly="true">
                </mat-form-field>
              </div>

              <div class="col-auto" *ngIf="f.formaPagamento.value === 'Boleto'">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                  <mat-label>Vencimento</mat-label>
                  <input id="vencimento" type="text" matInput formControlName="vencimentoBoleto" maxlength="100"
                    readonly="true">
                </mat-form-field>
              </div>

              <div class="col-auto" *ngIf="f.numeroParcelas.value === 2">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                  <mat-label>Valor boleto (2)</mat-label>
                  <input id="valorBoleto" type="text" matInput formControlName="valorBoleto2" maxlength="100"
                    readonly="true">
                </mat-form-field>
              </div>

              <div class="col-auto" *ngIf="f.numeroParcelas.value === 2">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                  <mat-label>Vencimento (2)</mat-label>
                  <input id="vencimento" type="text" matInput formControlName="vencimentoBoleto2" maxlength="100"
                    readonly="true">
                </mat-form-field>
              </div>

              <div class="col-auto" *ngIf="f.formaPagamento.value === 'Nota'">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                  <mat-label>Prazo da Nota</mat-label>
                  <input type="text" matInput formControlName="prazoNota" maxlength="100" readonly="true">
                </mat-form-field>
              </div>

              <div class="col-auto">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                  <mat-label>Status pagamento</mat-label>
                  <input id="status_pagamento" style="font-weight: 500;" type="text" matInput
                    formControlName="statusPagamento" maxlength="100" readonly="true">
                  <mat-hint align="start"><strong>{{f.dataHoraPagamentoPagoCancelado.value}}</strong>
                  </mat-hint>
                </mat-form-field>
              </div>

              <div class="col-sm" *ngIf="f.observacaoBoleto.value">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                  <mat-label>Observação</mat-label>
                  <input id="observacaoBoleto" type="text" matInput formControlName="observacaoBoleto" maxlength="100"
                    readonly="true">
                </mat-form-field>
              </div>

              <div class="col-sm" *ngIf="f.observacaoBoleto2.value">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                  <mat-label>Observação</mat-label>
                  <input id="observacaoBoleto" type="text" matInput formControlName="observacaoBoleto2" maxlength="100"
                    readonly="true">
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-auto">
                <button *ngIf="f.status.value !== 'Entregue' && f.status.value !== 'Cancelado'" mat-stroked-button
                  color="primary" class="mb-2 ml-2" (click)="alterarFormaPagamento()">
                  <mat-icon>edit</mat-icon> Alterar forma de pagamento
                </button>
              </div>

              <div class="col-auto">
                <button *ngIf="f.statusPagamento.value === 'Pendente' && f.formaPagamento.value !== 'Boleto'"
                  mat-stroked-button color="primary" class="mb-2" (click)="confirmarPagamento()">
                  <mat-icon>money</mat-icon> Confirmar pagamento
                </button>
              </div>

              <div class="col-auto" *ngIf="permitirGerarBoleto(1)">
                <button mat-stroked-button color="primary" class="mb-2" (click)="gerarBoleto(1)">
                  <mat-icon>money</mat-icon> Gerar Boleto
                </button>
              </div>

              <div class="col-auto" *ngIf="permitirGerarBoleto(2)">
                <button mat-stroked-button color="primary" class="mb-2" (click)="gerarBoleto(2)">
                  <mat-icon>money</mat-icon> Gerar Boleto (2)
                </button>
              </div>

              <div class="col-auto"
                *ngIf="!permitirGerarBoleto(1) && f.statusPagamento.value === 'Pendente' && f.formaPagamento.value === 'Boleto'">
                <button mat-stroked-button color="warn" class="mb-2" (click)="cancelarBoleto(1)">
                  <mat-icon>money</mat-icon> Cancelar boleto
                </button>
              </div>

              <div class="col-auto"
                *ngIf="!permitirGerarBoleto(2) && f.statusPagamento.value === 'Pendente' && f.formaPagamento.value === 'Boleto' && f.numeroParcelas.value === 2">
                <button mat-stroked-button color="warn" class="mb-2" (click)="cancelarBoleto(2)">
                  <mat-icon>money</mat-icon> Cancelar boleto (2)
                </button>
              </div>
            </div>

          </div>

          <!-- Fim coluna esquerda -->
        </div>

        <!-- Coluna à direita -->
        <div class="col-sm-3">
          <div class="row">
            <div class="col-auto">
              <h1 class="customH1">Produtos</h1>
            </div>
            <div class="col-sm">
              <hr />
            </div>

            <!-- <div class="col-auto">
              <button *ngIf="f.status.value !== 'Cancelado' && bRemoverProdutosCancelarPedido" mat-stroked-button
                color="warn" (click)="alertRemoverProdutos()">
                <mat-icon>edit</mat-icon> Alterar produtos
              </button>
            </div> -->
          </div>

          <div class="borda">
            <div class="row">
              <div class="col-sm ml-4 mb-2">
                <div *ngFor="let produto of f.produtos.value">
                  <div class="row mt-2">
                    <div class="col-sm" style="font-weight: 500; margin-left: 55px;">
                      {{produto.Nome}} <div *ngIf="produto.DescontoGrupoPromocional"
                        style="display: inline-block; font-size: smaller; color: gray;"> -
                        {{produto.NomeGrupoPromocional + ' | ' + produto.PorcentagemDesconto +
                        '%'}}</div>
                    </div>
                  </div>
                  <div class="row mt-1">
                    <div class="col-auto" style="display: inline-block; color: gray; margin-left: 5px;">
                      {{produto.QuantidadeComprada}} x
                    </div>

                    <div class="col-5" style="display: inline-block; color: #5474D4;">
                      R$ {{(!produto.DescontoGrupoPromocional ? produto.Valor :
                      (produto.ValorRealDesconto + ',' + produto.ValorCentavosDesconto))}}
                    </div>
                  </div>

                  <div class="row mt-2">
                    <div class="col-sm mr-4">
                      <mat-divider></mat-divider>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div class="row" *ngIf="f.valorDescontoVoucher.value">
              <div class="col-sm" style="font-weight: 500; text-align: center; color: red">
                R$ <div style="font-size: 12px; display: inline-block;">
                  {{f.valorDescontoVoucher.value.toFixed(2).replace('.',',')}} (Voucher)</div>
              </div>
            </div>

            <div class="row" *ngIf="f.valorDesconto.value">
              <div class="col-sm" style="font-weight: 500; text-align: center; color: red">
                R$ <div style="font-size: 12px; display: inline-block;">
                  {{f.valorDesconto.value.toFixed(2).replace('.',',')}} ({{f.porcentagemDesconto?.value}}% de desconto)
                </div>
              </div>
            </div>

            <div class="row mt-1 mb-1">
              <div class="col-sm" style="font-weight: 500; text-align: center;">
                R$ <div style="font-size: 18px; display: inline-block;">
                  {{f.valorRealString.value}},{{f.valorCentavosString.value}}</div>
              </div>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-auto">
              <h1 class="customH1">Alterar Status</h1>
            </div>
            <div class="col-sm">
              <hr />
            </div>
          </div>

          <div class="borda">
            <div class="row">
              <div class="col-auto">
                <mat-form-field appearance="fill" [floatLabel]="'always'">
                  <mat-label>Status</mat-label>
                  <mat-select formControlName="statusSelect">
                    <mat-option *ngFor="let tipo of aTipoStatus" [value]="tipo.value">
                      {{tipo.name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
          <!-- Fim coluna direita -->
        </div>

      </div>
    </form>

    <div class="row mt-4">
      <div class="col-sm">
        <mat-divider></mat-divider>
      </div>
      <!-- <section fxLayout fxLayoutAlign="space-between center" class="mtSection"> -->
      <!-- </section> -->
    </div>
    <div class="row mt-2">
      <div class="col-auto">
        <button mat-flat-button color="warn" (click)="voltar()">
          <mat-icon>arrow_back</mat-icon> Voltar
        </button>
      </div>

      <div class="col-sm text-right">
        <!-- <button
          *ngIf="f.status.value !== 'Confirmado' && f.status.value !== 'Cancelado' && bRemoverProdutosCancelarPedido"
          mat-stroked-button color="basic" class="mr-4" (click)="retornarStatusPedido()">
          <mat-icon>keyboard_return</mat-icon> Retornar status do pedido
        </button> -->
        <!-- //Autorizado a alteração de status temporariamente para liberar a alteração de forma de pagamento e baixar pedidos antes do boleto automático -->
        <button *ngIf="f.status.value !== 'Confirmado' && f.status.value !== 'Cancelado'" mat-stroked-button
          color="basic" class="mr-4" (click)="retornarStatusPedido()">
          <mat-icon>keyboard_return</mat-icon> Retornar status do pedido
        </button>

        <button *ngIf="f.status.value !== 'Cancelado' && bRemoverProdutosCancelarPedido" mat-stroked-button color="warn"
          class="mr-4" (click)="cancelarPedido()">
          <mat-icon>cancel</mat-icon> Cancelar pedido
        </button>

        <button *ngIf="f.status.value !== 'Entregue' && f.status.value !== 'Cancelado'" mat-flat-button color="primary"
          (click)="atualizar()">
          <mat-icon>check</mat-icon> Atualizar
        </button>
      </div>
    </div>
  </mat-card-content>
</mat-card>